<template>
  <div>
    <card class="card-user">
      <div slot="image">
        <div v-if="files.length > 0">
          <label for="avatar" class="company-avatar">
            <img class="company-avatar__img" :src="files[0].url" alt="..." />
            <span class="company-avatar__upload">
              <i class="fas fa-cloud-upload-alt"></i> Click or Drop file to upload
            </span>
          </label>
        </div>
        <div v-else slot="image" class="card-img">
          <div v-if="companyCopy.avatar">
            <label for="avatar" class="company-avatar">
              <img class="company-avatar__img" :src="companyCopy.avatar" alt="..." />
              <span class="company-avatar__upload">
                <i class="fas fa-cloud-upload-alt"></i> Click or Drop file to upload
              </span>
            </label>
          </div>
          <div v-else>
            <label for="avatar" class="company-avatar">
              <img
                class="company-avatar__img"
                src="../../../assets/img/matthew-mcbrayer-fZL3EN4aJUI-unsplash.jpg"
                alt="..."
              />
              <span class="company-avatar__upload">
                <i class="fas fa-cloud-upload-alt"></i> Click or Drop file to upload
              </span>
            </label>
          </div>
        </div>

        <file-upload
          extensions="jpg,jpeg,png"
          accept="image/*"
          :multiple="false"
          name="avatar"
          :custom-action="uploadFile"
          :drop="true"
          v-model="files"
          @input-filter="inputFilter"
          @input-file="inputFile"
          ref="upload"
        >
        </file-upload>
      </div>

      <div class="avatar-upload">
        <div v-if="fileAttached">
          <p-button class="mr-2" type="danger" @click.native.prevent="remove(files)"> Remove </p-button>
          <p-button type="success" :loading="loadingSave" @click.native.prevent="$refs.upload.active = true">
            Upload
          </p-button>
        </div>
      </div>

      <div v-if="showDeleteCompany" class="card__deleteButton">
        <p-button type="danger" icon outline @click.native.prevent="openDelete = true">
          <i class="fas fa-trash" />
        </p-button>
      </div>
      <div>
        <div class="author">
          <img class="avatar border-white" src="../../../assets/img/clientLogo_presentation.png" alt="..." />
          <h4 class="title">{{ companyCopy.name }}</h4>
        </div>
        <p class="description text-center">
          {{ companyCopy.description }}
        </p>
        <div class="text-center">
          <a :href="companyCopy.company_website" class="website" target="_blank">
            {{ companyCopy.company_website }}
          </a>
        </div>
      </div>
      <hr />
      <div class="text-center mt-5">
        <div class="row">
          <div class="col">
            <h5>
              {{ companyCopy.roles.length }}
              <br />
              <small>Roles</small>
            </h5>
          </div>

          <div class="col">
            <h5>
              {{ members.length }}
              <br />
              <small>Active Users</small>
            </h5>
          </div>

          <div class="col">
            <h5>
              {{ companyCopy.created_at }}
              <br />
              <small>Created at</small>
            </h5>
          </div>
        </div>
      </div>
    </card>

    <ModalTemplate
      component-name="DeleteModal"
      action="destroyCompany"
      button-component-name="DeleteButton"
      :data="{
        deletion_object_name: companyCopy.name,
        deletion_object_text: $t('this_company'),
        delete_button_title: $t('delete_company'),
        header: $t('delete_company'),
      }"
      :clicked="openDelete"
      @submit="deleteCompany()"
    >
    </ModalTemplate>
  </div>
</template>
<script>
import ModalTemplate from '../../../components/modals/ModalTemplate';
import axiosAuth from '../../../axiosMain';
import UsersController from '@/controllers/Users/UsersController';
import Cropper from 'cropperjs';
import CompanyController from '@/controllers/Company/CompanyController';

export default {
  components: { ModalTemplate },
  props: {
    company: {
      type: Object,
    },
    members: {
      type: Array,
    },
    showDeleteCompany: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openDelete: false,
      files: [],
      edit: false,
      cropper: false,
      fileAttached: false,
      loadingSave: false,
      companyCopy: null,
    };
  },
  async mounted() {
    await this.setCompany();
  },
  methods: {
    getClasses(index) {
      var remainder = index % 3;
      if (remainder === 0) {
        return 'col-lg-3 offset-lg-1';
      } else if (remainder === 2) {
        return 'col-lg-4';
      } else {
        return 'col-lg-3';
      }
    },
    deleteCompany: function () {
      axiosAuth
        .delete('/companies/' + this.$route.params.id, {
          headers: {
            Authorization: 'Bearer ' + this.$store.getters.token,
          },
        })
        .then((response) => {
          this.$router.push('/super_user');
          this.$notify({
            type: 'success',
            title: this.$t('Successful'),
            text: this.$t('The_company_was_deleted'),
          });
        })
        .catch((errors) => {
          this.$notify({
            type: 'error',
            title: this.$t('Error') + ' ' + errors.response.status,
            text: errors.response.data[0],
          });
        });
    },
    async uploadFile(file) {
      try {
        this.loadingSave = true;
        this.companyCopy = await CompanyController.update(this.companyCopy.company_id, {
          avatar_url: this.files[0].file,
        });
        this.remove(this.files);
        this.$notify({
          type: 'success',
          title: 'New company avatar was saved',
        });
        this.loadingSave = false;
      } catch (error) {
        this.loadingUpload = false;
        Object.entries(error.response.data).forEach((item) => {
          this.$notify({
            type: 'danger',
            title: item[1],
          });
        });
      }
    },

    remove(files) {
      let vm = this;
      files.forEach((file) => {
        vm.$refs.upload.remove(file);
      });
      this.fileAttached = false;
    },

    inputFile() {
      this.fileAttached = true;
    },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        if (!/\.(jpg|jpeg|png)$/i.test(newFile.name)) {
          this.alert('Format of your file is invalid');
          return prevent();
        }
      }
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.url = '';
        let URL = window.URL || window.webkitURL;
        if (URL && URL.createObjectURL) {
          newFile.url = URL.createObjectURL(newFile.file);
        }
      }
    },
    alert(message) {
      alert(message);
    },
    editSave() {
      this.edit = false;
      let oldFile = this.files[0];
      let binStr = atob(this.cropper.getCroppedCanvas().toDataURL(oldFile.type).split(',')[1]);
      let arr = new Uint8Array(binStr.length);
      for (let i = 0; i < binStr.length; i++) {
        arr[i] = binStr.charCodeAt(i);
      }
      let file = new File([arr], oldFile.name, { type: oldFile.type });
      this.$refs.upload.update(oldFile.id, {
        file,
        type: file.type,
        size: file.size,
        active: true,
      });
    },
    async setCompany() {
      this.companyCopy = this.company;
    },
  },
};
</script>
<style>
.avatar-upload {
  text-align: center;
}
</style>
